import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { NavigationService } from '../../services';
import * as fromNavigation from '../actions/navigation.actions';

@Injectable()
export class NavigationEffects {

  constructor(private actions$: Actions, private navigationService: NavigationService) { }

  @Effect()
  load$ = this.actions$.ofType(fromNavigation.NavigationActionTypes.Load)
    .switchMap(() => {
      return this.navigationService.getNodes()
        .map(nodes => new fromNavigation.LoadSuccess(nodes))
        .catch(error => new console.log(error))
    });

}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/navigation.effects.ts